import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light", // Can be changed to "dark" for a dark mode
    primary: {
      main: "#000000", // Black
    },
    secondary: {
      main: "#ffffff", // White
    },
    background: {
      default: "#f8f8f8", // Light gray background
      paper: "#ffffff",
    },
    text: {
      primary: "#000000", // Black text
      secondary: "#555555", // Dark gray text
    },
  },
  typography: {
    fontFamily: '"Arial", sans-serif',
    fontWeightBold: 700,
    button: {
      textTransform: "none", // Prevents uppercase on buttons
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          border: "2px solid black",
          color: "black",
          fontWeight: "bold",
          color: "white",
          "&:hover": {
            backgroundColor: "#444",
            color: "white",
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent", // No background color
          color: "black",
          borderBottom: "1px solid #444",
          boxShadow: "none", // Remove shadow
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          maxWidth: "1000px",
          margin: "auto",
          padding: "20px",
        },
      },
    },
  },
});

export default theme;
